module.exports = __webpack_public_path__ + "static/media/cov_too_equ_sur.adeef89c.png";